import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  createMembershipRequest,
  getMemberships,
  removeMembership,
  updateMembershipRequest,
} from "../../../../services/api/landing/memberships/membershipsApi";

const getLang = () =>
  localStorage.getItem("language") === "ar" ? "ar" : "en";

const toastMessages = {
  add: {
    en: "Membership created successfully!",
    ar: "تم إنشاء العضوية بنجاح!",
  },
  addError: {
    en: "Failed to create membership.",
    ar: "فشل في إنشاء العضوية.",
  },
  update: {
    en: "Membership updated successfully!",
    ar: "تم تحديث العضوية بنجاح!",
  },
  updateError: {
    en: "Failed to update membership.",
    ar: "فشل في تحديث العضوية.",
  },
  delete: {
    en: "Membership deleted successfully!",
    ar: "تم حذف العضوية بنجاح!",
  },
  deleteError: {
    en: "Failed to delete membership.",
    ar: "فشل في حذف العضوية.",
  },
};

export const fetchMemberships = createAsyncThunk(
  "memberships/fetchMemberships",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getMemberships();
      return response.data.data;
    } catch (error) {
      return rejectWithValue("Failed to fetch memberships");
    }
  },
);

export const createMembership = createAsyncThunk(
  "memberships/createMembership",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await createMembershipRequest(formData);
      return response.data.data;
    } catch (error) {
      return rejectWithValue("Failed to create membership");
    }
  },
);

export const updateMembership = createAsyncThunk(
  "memberships/updateMembership",
  async ({ membershipId, formData }, { rejectWithValue }) => {
    try {
      const response = await updateMembershipRequest(membershipId, formData);
      return response.data.data;
    } catch (error) {
      return rejectWithValue("Failed to update membership");
    }
  },
);

export const deleteMembership = createAsyncThunk(
  "memberships/deleteMembership",
  async (membershipId, { rejectWithValue }) => {
    try {
      await removeMembership(membershipId);
      return membershipId;
    } catch (error) {
      return rejectWithValue("Failed to delete membership");
    }
  },
);

const membershipSlice = createSlice({
  name: "memberships",
  initialState: {
    membershipData: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMemberships.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMemberships.fulfilled, (state, action) => {
        state.loading = false;
        state.membershipData = action.payload;
      })
      .addCase(fetchMemberships.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createMembership.fulfilled, (state, action) => {
        state.membershipData.push(action.payload);
        toast.success(toastMessages.add[getLang()]);
      })
      .addCase(createMembership.rejected, (state, action) => {
        state.error = action.payload;
        toast.error(toastMessages.addError[getLang()]);
      })
      .addCase(updateMembership.fulfilled, (state, action) => {
        const index = state.membershipData.findIndex(
          (membership) => membership.id === action.payload.id,
        );
        if (index !== -1) {
          state.membershipData[index] = action.payload;
        }
        toast.success(toastMessages.update[getLang()]);
      })
      .addCase(updateMembership.rejected, (state, action) => {
        state.error = action.payload;
        toast.error(toastMessages.updateError[getLang()]);
      })
      .addCase(deleteMembership.fulfilled, (state, action) => {
        state.membershipData = state.membershipData.filter(
          (membership) => membership.id !== action.payload,
        );
        toast.success(toastMessages.delete[getLang()]);
      })
      .addCase(deleteMembership.rejected, (state, action) => {
        state.error = action.payload;
        toast.error(toastMessages.deleteError[getLang()]);
      });
  },
});

export default membershipSlice.reducer;
